import { useMutation } from "@tanstack/react-query";
import type { ResponsePromise } from "ky";
import { useState } from "react";

import { api } from "~/shared/services/api/fetch-client.ts";

import type { StopLocation } from "../../shared/ftl-stop.ts";

type Country = {
	name: string;
	abbreviation: string;
};

type State = {
	name: string;
	abbreviation: string;
	country: Country;
};

type City = {
	name: string;
	state: State;
};

export type LocationVM = {
	id: string;
	postalCode: string;
	city: City;
	longitude: number;
	latitude: number;
};

const search = async (
	searchCriteria: string,
): Promise<ResponsePromise<LocationVM[]>> => {
	return await api.get<LocationVM[]>(
		`locations?searchString=${searchCriteria}`,
	);
};

export function useLocationSearch(initialData?: StopLocation[]) {
	const [locationsData, setLocationsData] = useState<
		StopLocation[] | undefined
	>(initialData);

	const { mutate, isPending } = useMutation({
		mutationFn: search,
		onSuccess: (data) => {
			const response = data.json();
			response.then((res: LocationVM[]) => {
				const locations: StopLocation[] = [];
				for (const location of res) {
					const locationData: StopLocation = {
						id: location.id,
						location: `${location.city.name}, ${location.city.state.abbreviation} ${location.postalCode}, ${location.city.state.country.abbreviation}`,
						city: location.city.name,
						state: location.city.state.abbreviation,
						country: location.city.state.country.abbreviation,
						postalCode: location.postalCode,
						longitude: location.longitude,
						latitude: location.latitude,
					};
					locations.push(locationData);
				}
				setLocationsData(locations);
			});
		},
		onError: (error) => {
			// Handle error
			console.error("Error searching locations:", error);
		},
	});

	return {
		isPending,
		search: mutate,
		locationsData,
	};
}
